import React, { FC } from "react";
import { IconContainer } from "shared/icons/IconContainer";

export const RichTextBlockIcon: FC<React.ComponentProps<typeof IconContainer>> = ({ ...props }) => (
  <IconContainer {...props} viewBox="0 0 16 16">
    <path
      d="M2 4.66683V3.3335H10.6667V4.66683M6.66667 3.3335V12.6668M8 12.6668H5.33333M10 8.66683V8.00016H14V8.66683M12 8.00016V12.6668M11.3333 12.6668H12.6667"
      stroke="currentColor"
      strokeWidth="1.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconContainer>
);
